import { FormControl, Button } from "react-bootstrap";
import omit from "lodash/omit";
// hooks
import { useAddendums } from "../../scenes/note-fill-in/contexts/AddendumsContext";
// components
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import Delete from "./components/delete";
// constants
import messages from "messages";
// styles
import styles from "./Addendums.module.scss";
import { useMemo } from "react";

type Props = {
  id: string;
};
const Addendums = ({ id }: Props) => {
  const { addendums, canAdd, addendum, setAddendum } = useAddendums();

  const addendumsById: string[] = useMemo(
    () =>
      (addendums || []).reduce((prev, curr) => {
        if (curr.addendum?.[id]) {
          prev.push(curr.addendum[id]);
        }
        return prev;
      }, [] as string[]),
    [id, addendums],
  );

  const showAdd = useMemo(() => {
    // sanity check
    if (!addendum) {
      return false;
    }
    if (!canAdd) {
      return false;
    }

    if (id in addendum) {
      return false;
    }

    return true;
  }, [canAdd, addendum, id]);

  return (
    <div className={styles["addendums"]}>
      {(addendumsById || []).map((el, index) => {
        return (
          <div className={styles["addendums__item"]} key={index}>
            {/* title */}
            <div className={styles["addendums__title"]}>
              {messages.addendum + " #" + (index + 1)}
            </div>

            <FormControl
              as={"div"}
              className={styles["addendums__input"]}
              children={el || ""}
              readOnly={true}
            />
          </div>
        );
      })}
      {id in addendum && (
        <div className={styles["addendums__item"]}>
          {/* title */}
          <div className={styles["addendums__title"]}>
            {messages.addendum + " #" + (addendumsById.length + 1)}

            <Delete
              onDelete={() => setAddendum && setAddendum(omit(addendum, id))}
            />
          </div>

          <FormControl
            as={"textarea"}
            className={styles["addendums__input"]}
            rows={3}
            placeholder={messages.enterAddendum}
            value={addendum[id] || ""}
            onChange={(e) =>
              setAddendum &&
              setAddendum({
                ...addendum,
                [id]: e.target.value,
              })
            }
          />
        </div>
      )}
      {/* no previous data or all data is signed */}
      {showAdd && (
        <Button
          className={styles["addendums__create"]}
          variant={"link"}
          onClick={() =>
            setAddendum &&
            setAddendum({
              ...addendum,
              [id]: "",
            })
          }
        >
          <OutlinePlus16 />
          <span className={styles["addendums__create-label"]}>
            {messages.addAddendum}
          </span>
        </Button>
      )}
    </div>
  );
};

export default Addendums;
